import { variables as carlecVariables } from "@pg-flex/shared-js/theme/VariablesStyle";

import { isStaging } from "@/valor-utils/isEnv";

const statusVariables = {
  "status-draft-color": "#70989d",
  "status-priced-color": "#70989d",
  "status-validated-color": "var(--total-blue)",
  "status-accepted-color": "var(--total-blue)",
  "status-inportfolio-color": "var(--total-blue)",
  "status-rejected-color": "#AC0929",
  "status-finished-color": "#28292b",
};
// Expose variables as JS object.
export const variables = {
  // Reuse carlec's variables
  ...carlecVariables,
  // Specific contract status variables
  ...statusVariables,

  // Valor overwrites for staging env
  "active-menu-color": isStaging ? "var(--total-red)" : "var(--total-blue)",
  "link-button-color": isStaging
    ? "var(--total-red)"
    : "var(--total-lightblue)",
  "secondary-button-color": isStaging
    ? "var(--total-red)"
    : "var(--total-lightblue)",
  "primary-button-gradient": isStaging
    ? "linear-gradient(112deg, var(--total-gradient-red-2) 0%, var(--total-gradient-red-1) 100%)"
    : "linear-gradient(112deg, var(--total-gradient-blue-2) 0%, var(--total-gradient-blue-1) 100%)",
  "switch-button-gradient": isStaging
    ? "linear-gradient(129deg, var(--total-gradient-red-1) 0%, var(--total-gradient-red-2) 100%)"
    : "linear-gradient(129deg, var(--total-gradient-lightblue-1) 0%, var(--total-gradient-lightblue-2) 100%)",
  "group-select-gradient": isStaging
    ? "linear-gradient(137deg, var(--total-gradient-red-2) 0%, var(--total-gradient-red-1) 100%)"
    : "linear-gradient(137deg, var(--total-gradient-blue-2) 0%, var(--total-gradient-blue-1) 100%)",
  "focus-color": isStaging
    ? "var(--total-gradient-red-2)"
    : "var(--total-gradient-blue-2)",
};
// Plotly can't use CSS variables so we export some raw colors here.

export const plotVariables = {
  "grid-color": "#d1dedf",
  "text-font": "'Nunito', sans-serif",
  "title-font": "'Nunito', sans-serif",
  "title-text-color": "#2e2e2e",
  "primary-text-color": "#28292b",
  "secondary-text-color": "#70989d", // Pearl
  "separator-color": "#d1dedf",
  "secondary-background-color": "#f5f8f8",
};
